import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import { HeroBadge, useFeedbackModal } from "@components/ui";
import {
  HeroSection,
  WhyTrustSection,
  ResidentialServicesDetailSection,
  SafetyTipsSection,
  CommunitySolutionsSection,
  MoveInOutSection,
  CustomerPortalSection,
  EmergencyCTASection,
} from "../../components";

export function GasSolutions() {
  const { openModal } = useFeedbackModal();

  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Safe, Reliable Gas Solutions for Your Home"
        description="Whether you live in an apartment, villa, townhouse, or community compound, GAZ ensures safe and efficient gas supply, transparent billing, and 24/7 emergency support — so you can enjoy peace of mind."
        heroImage={heroImage}
        badge={
          <HeroBadge
            text="Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business."
            linkText="Report an Emergency Online"
            icon={<img src={emergencyIcon} alt="" className="w-7 h-7" />}
            onLinkClick={() => openModal("Emergency / Maintenance")}
          />
        }
      />
      <WhyTrustSection />
      <ResidentialServicesDetailSection />
      <SafetyTipsSection />
      <CommunitySolutionsSection />
      <MoveInOutSection />
      <CustomerPortalSection />
      <EmergencyCTASection
        title="Need Help with your Bill or Account"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GAZ (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        <div className="rounded-3xl bg-white flex flex-col items-start p-4 md:p-6 gap-2.5">
          <div className="flex flex-col gap-3 md:gap-5">
            <div className="flex items-center gap-2">
              <div className="flex flex-col gap-3.5">
                <img src={mailIcon} alt="" className="w-4 h-4" />
                <img src={phoneIcon} alt="" className="w-4 h-4" />
              </div>
              <div className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
                help@gazglobal.net
                <br />
                Support (8 AM – 8 PM)
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <img src={buildingIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />
            <span className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
              Sunday – Thursday (8 AM – 6 PM)
            </span>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default GasSolutions;
